<template>
  <v-form
    ref="reset-pass-form"
    v-model="valid"
    lazy-validation
    class="reset-pass-form d-flex"
    @submit.prevent="onSubmit"
    id="reset-pass-form"
  >
    <div class="reset-pass-form-main pa-4 justify-center">
      <h1 class="text-center font-weight-bold mb-10 mt-4" v-translate>RESET PASSWORD?</h1>
      <p v-translate>Enter the your password.</p>
      <label class="titleForm d-flex pb-2">Password</label>
      <v-text-field
        v-model="password"
        :rules="emptyRules"
        :type="showInput ? 'text' : 'password'"
        :append-icon="showInput ? 'fal fa-eye' : 'fal fa-eye-slash'"
        @click:append="showInput = !showInput"
        outlined
        required
      ></v-text-field>
      <label class="titleForm d-flex pb-2" v-translate>Confirm password</label>
      <v-text-field
        v-model="confirmPassword"
        :rules="[confirmPasswordCheck]"
        :type="showInput ? 'text' : 'password'"
        :append-icon="showInput ? 'fal fa-eye' : 'fal fa-eye-slash'"
        @click:append="showInput = !showInput"
        outlined
        required
      ></v-text-field>

      <v-alert v-if="messageError" dense text type="error">
        {{ messageError }}
      </v-alert>
      <v-alert v-if="messageSuccess" dense text type="success">
        {{ messageSuccess }}
      </v-alert>

      <div class="text-center">
        <v-btn
          large
          color="primary"
          class="text-none subtitle-1 font-weight-bold rounded-0"
          type="submit"
          form="reset-pass-form"
          width="200"
          min-height="58"
          v-if="!messageSuccess"
        >
          <translate>Submit</translate>
        </v-btn>
      </div>
    </div>
  </v-form>
</template>
<script>
import { mapActions } from "vuex";
import Vue from 'vue';
export default {
  name: "ResetPassForm",
  data: () => ({
    messageError: "",
    messageSuccess: "",
    valid: true,
    emptyRules: [
      (v) => !!v || Vue.prototype.$gettext("Field is required"),
      // v => (v && v.length <= 10) || 'Field must be less than 10 characters',
    ],
    showInput: false,
    password: "",
    confirmPassword: "",
    token: "",
  }),
  watch: {
    "$route.query": {
      immediate: true,
      handler(val) {
        let token = val.token;
        if (!token) {
          this.$router.replace("/");
        }
        this.token = token;
      },
    },
  },
  methods: {
    ...mapActions({
      resetPassword: "resetPassword",
    }),
    confirmPasswordCheck(v) {
      if (v.length) {
        if (this.password === v) {
          return true;
        } else {
          return this.$gettext("Confirm password do not match");
        }
      } else {
        return this.$gettext("Confirm password required");
      }
    },
    async onSubmit() {
      if (this.$refs["reset-pass-form"].validate()) {
        const result = await this.resetPassword({
          password: this.password,
          token: this.token,
        });
        if (result.error) {
          this.messageError = this.$gettext(result.error.message);
          this.messageSuccess = "";
        } else {
          this.messageError = "";
          this.messageSuccess = this.$gettext("Change password success !");
          this.$router.push({name: 'login'})
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.reset-pass-form {
  background: #f2f3f5;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  align-items: center;
}
.reset-pass-form-main {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}
.reset-pass-form-main > h1 {
  font-size: 2.5rem;
  text-transform: uppercase;
  font-weight: bolder;
}
</style>
